class ProductRecommendations extends window.HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.fetchRecommendations();
    }
  
    fetchRecommendations() {
        fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement("div")
                html.innerHTML = text
                const recommendations = html.querySelector("product-recommendations")

                if (recommendations?.innerHTML.trim().length) {
                    this.innerHTML = "";
                    this.appendChild(recommendations.firstElementChild);
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }
}
  
window.customElements.define('product-recommendations', ProductRecommendations)